export const MAX_TITLE_LENGTH = 100;

export const HEADER_HEIGHT = 80;

export const AUDIO_PLAYER_HEIGHT = 62;

export const MAX_CHARACTER_PER_BLOCK = 1000;

export const PROJECT_PRODUCT = {
  DUBBING: 'DUBBING',
  TTS: 'TTS',
};

export const VALID_VOLUME = { MIN: 0, MAX: 100 };

export const CONVERTING_STATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
};

export const PLAYING_TYPE = {
  BLOCK: 'BLOCK',
  ALL_BLOCKS: 'ALL_BLOCKS',
};

export const DIRECTION = {
  UP: 'up',
  DOWN: 'down',
};

export const DISPLAY_SUCCESS_ICON_DURATION = 3000;

export const NUMBER_OF_BLOCKS_PER_BATCH = 1;

export const AUDIO_MODE = {
  JOINED: 'joined',
  SEPARATE: 'separate',
};
